module.exports = __webpack_public_path__ + "static/media/slider1.b54bc62d.png";